import React from "react";
import "./CareerGrowthZone.css";

const CareerGrowthZone = () => {
  return (
    <section className="career-growth-section">
      <div className="career-growth-container">
        <div className="career-growth-header">
          <h4 className="career-subtitle">Building Stronger Professionals</h4>
          <h2 className="career-title">
            Career Guidance, Resume Writing & Profile Optimization
          </h2>
          <p className="career-description">
            Your profile is your brand — and we help you present it perfectly.
            From crafting compelling resumes to optimizing your LinkedIn and
            Naukri profiles, we make sure you attract the right recruiters and
            opportunities.
          </p>
        </div>

        <div className="career-card-wrapper">
          <div className="career-card resume-card">
            <div className="icon">📝</div>
            <h3>Resume Writing</h3>
            <p>
              Tailored resumes designed for ATS and hiring managers to get you
              noticed.
            </p>
          </div>

          <div className="career-card profile-card">
            <div className="icon">🔗</div>
            <h3>LinkedIn & Naukri Optimization</h3>
            <p>
              Enhance your online presence and make your profile
              recruiter-ready.
            </p>
          </div>

          <div className="career-card mentorship-card">
            <div className="icon">🎯</div>
            <h3>Career Mentorship</h3>
            <p>
              Personalized sessions to guide your growth and career direction.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerGrowthZone;
